import { useLayoutStore } from '@/stores/layoutStore';
import { useSessionStore } from '@/stores/sessionStore';
import { useFlowStore } from '@/stores/flowStore';
import { useSettingsStore } from '@/stores/settingsStore';
import { FINISH } from '@/router/routes.names';
import { HTTP_UNAUTHORIZED } from '@/common/axios/httpStatusCodes';
import { THANK_YOU } from '@/names/pages.names';
import type { RouteRecordRaw } from 'vue-router';

const finishRoute: RouteRecordRaw[] = [
  {
    path: 'finish',
    name: FINISH,
    component: () => import('@/views/Finish.vue'),
    beforeEnter: async (to, from, next) => {
      const layoutStore = useLayoutStore();
      const sessionStore = useSessionStore();
      const flowStore = useFlowStore();
      const settingsStore = useSettingsStore();

      const params = {
        recruitmentProcessId: Array.isArray(to.params.recruitmentProcessId)
          ? to.params.recruitmentProcessId[0]
          : to.params.recruitmentProcessId,
        sessionId: Array.isArray(to.params.sessionId)
          ? to.params.sessionId[0]
          : to.params.sessionId,
      };

      try {
        layoutStore.startLoading();
        await settingsStore.fetchPageTranslation(
          params.recruitmentProcessId,
          params.sessionId,
          THANK_YOU
        );
        await sessionStore.fetchSessionGameData();

        if (sessionStore.gameIsStarted) {
          await sessionStore.fetchGameStages();
        }

        const areAllStagesCompleted = flowStore.areAllStagesCompleted;
        const gameIsFinished = sessionStore.gameIsFinished;

        if (!areAllStagesCompleted && !gameIsFinished) {
          await flowStore.redirectToCurrentStage();
        }

        next();
      } catch (e: any) {
        const statusCode = e.response?.status;

        if (statusCode === HTTP_UNAUTHORIZED) {
          next();
          return;
        }
        throw new Error(e.message || 'An error occurred during navigation.');
      } finally {
        layoutStore.stopLoading();
      }
    },
  },
];

export default finishRoute;
